// React is auto-imported with JSX transform
import { Message, Poll } from '../../types/community';
import { MessageItem } from './MessageItem';
import { PollItem } from './PollItem';

interface MessageListProps {
  messages: Message[];
  polls: Poll[];
  isAdmin: boolean;
  currentUserId?: string;
  onTogglePin: (messageId: string, isPinned: boolean) => void;
  onDelete: (messageId: string, userId: string) => void;
  onAddComment: (messageId: string, content: string) => Promise<boolean>;
  onToggleLike: (messageId: string) => void;
  onVotePoll: (pollId: string, optionId: string) => Promise<boolean>;
  onDeletePoll: (pollId: string) => Promise<boolean>;
  onViewThread?: (threadId: string) => void; // New prop for opening thread view
  onOpenCategoryModal?: (messageId: string) => void;
}

export function MessageList({
  messages,
  polls,
  isAdmin,
  currentUserId,
  onTogglePin,
  onDelete,
  onToggleLike,
  onAddComment,
  onVotePoll,
  onDeletePoll,
  onViewThread,
  onOpenCategoryModal,
}: MessageListProps) {
  // Combine messages and polls into a single timeline
  const timeline = [
    ...messages.map(m => ({ type: 'message' as const, data: m, timestamp: new Date(m.created_at).getTime() })),
    ...polls.map(p => ({ type: 'poll' as const, data: p, timestamp: new Date(p.created_at).getTime() }))
  ].sort((a, b) => b.timestamp - a.timestamp);

  return (
    <div className="space-y-4 max-w-full overflow-hidden relative z-30">
      {timeline.map((item) => (
        item.type === 'message' ? (
          <MessageItem
            key={`message-${item.data.id}`}
            message={item.data}
            isAdmin={isAdmin}
            currentUserId={currentUserId}
            onTogglePin={onTogglePin}
            onDelete={onDelete}
            onAddComment={onAddComment}
            onOpenCategoryModal={onOpenCategoryModal}
            onToggleLike={onToggleLike}
            onViewThread={onViewThread}
          />
        ) : (
          <PollItem
            key={`poll-${item.data.id}`}
            poll={item.data}
            isAdmin={isAdmin}
            onVote={onVotePoll}
            onDelete={onDeletePoll}
          />
        )
      ))}
    </div>
  );
}